import { Injectable } from '@angular/core';
import {
  ServiceAppointment as Appointment,
  AppointmentCase,
  ServiceAppointmentDeclinedMpviCode
} from '@quorum/models/xs-resource';

import { Actions, createEffect } from '@ngrx/effects';
import { DataPersistence } from '@nrwl/angular';
import { ApiService } from '@quorum/api';
import * as fromAppointments from './appointments.actions';
import { AppointmentsState } from './appointments.interfaces';
import { map } from 'rxjs/operators';

@Injectable()
export class AppointmentsEffects {
  
  getAppointmentsFromServer = createEffect(() => this.dataPersistence.fetch(fromAppointments.GET_APPOINTMENT_FROM_SERVER, {
    run: (action: fromAppointments.GetAppointmentFromServer, state: AppointmentsState) => {
      return this.apiService
        .get<Appointment>(`v/2/fixed-operations/appointments/` + action.payload.id, { params: action.payload.query })
        .pipe(map(appointment => new fromAppointments.GetAppointmentFromServerSuccess(appointment)));
    },
    onError: (action: fromAppointments.GetAppointmentFromServer, error) => {
      console.error('Error', error);
    }
  }));

  
  createAppointmentCase = createEffect(() => this.dataPersistence.pessimisticUpdate(fromAppointments.POST_APPOINTMENT_CASE_TO_SERVER, {
    run: (action: fromAppointments.PostAppointmentCaseToServer, state: AppointmentsState) => {
      return this.apiService
        .post<AppointmentCase>(`v/1/fixed-operations/appointment-cases`, action.payload.case)
        .pipe(
          map(appointmentCase => new fromAppointments.PostAppointmentCaseToServerSuccess({ case: appointmentCase }))
        );
    },
    onError: (action: fromAppointments.PostAppointmentCaseToServer, error) => {
      console.error('Error', error);
    }
  }));

  
  declineServiceOnAppointment = createEffect(() => this.dataPersistence.pessimisticUpdate(
    fromAppointments.POST_APPOINTMENT_DECLINED_SERVICE_TO_SERVER,
    {
      run: (action: fromAppointments.PostAppointmentDeclinedServiceToServer, state: AppointmentsState) => {
        return this.apiService
          .post<ServiceAppointmentDeclinedMpviCode>(
            `v/1/fixed-operations/service-appointment-declined-mpvi-codes`,
            action.payload.declinedService
          )
          .pipe(
            map(
              declinedService =>
                new fromAppointments.PostAppointmentDeclinedServiceToServerSuccess({ declinedService: declinedService })
            )
          );
      },
      onError: (action: fromAppointments.PostAppointmentDeclinedServiceToServer, error) => {
        console.error('Error', error);
      }
    }
  ));
  constructor(
    private actions: Actions,
    private dataPersistence: DataPersistence<AppointmentsState>,
    private apiService: ApiService
  ) {}
}
